import {
  AfterContentChecked,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  NgModule,
  OnInit,
  Renderer2,
} from '@angular/core';
import { AssetsService } from '@app/core/assets/assets.service';
import { tap } from 'rxjs';

@Directive({ selector: '[icon]' })
export class IconDirective implements OnInit, AfterContentChecked {
  @HostBinding('style.display') public display = 'flex';
  @HostBinding('style.align-items') public alignItems = 'center';
  @Input() public iconName: string;
  private readonly element: Element;
  private cache = new Map<string, any>();

  constructor(
    private assetService: AssetsService,
    private renderer: Renderer2,
    private cd: ChangeDetectorRef,
    element: ElementRef,
  ) {
    this.element = element.nativeElement;
  }

  ngOnInit() {
    if (this.iconName) this.loadIcon(this.iconName);
  }

  ngAfterContentChecked(): void {
    this.element.setAttribute('style', 'line-height: 0.5rem');
    const children = this.element.children;
    let length = children.length;
    if (children.length) {
      while (length--) {
        const child = children[length];
        if (child.tagName.toLowerCase() === 'svg') {
          this.normalizeSvgElement(child as SVGElement);
        }
      }
    }
  }

  private normalizeSvgElement(svg: SVGElement): void {
    if (!svg.getAttribute('viewBox')) {
      this.renderer.setAttribute(svg, 'viewBox', '0 0 1024 1024');
    }
    // this.renderer.setAttribute(svg, 'width', '100%');
    this.renderer.setAttribute(svg, 'height', '1em');
    this.renderer.setAttribute(svg, 'fill', 'currentColor');
  }

  private loadIcon(icon: string) {
    const iconName = `${icon}.svg`;
    if (this.cache.has(iconName)) {
      this.element.innerHTML = this.cache.get(iconName);
      this.cd.markForCheck();
      return;
    }
    this.assetService
      .getIcon(iconName)
      .pipe(
        tap((result) => {
          this.cache.set(iconName, result);
        }),
      )
      .subscribe((content) => {
        this.element.innerHTML = content;
        this.cd.markForCheck();
      });
  }
}

@NgModule({
  imports: [IconDirective],
  exports: [IconDirective],
  providers: [],
})
export class IconModule {}
